module.exports = __webpack_public_path__ + "static/media/file-with-search.2d3f2ba3.svg";